import React, {Component} from 'react';
import {Helmet} from 'react-helmet';
import {NavLink, withRouter} from 'react-router-dom';
import {NavToggle} from '..';
// import { getLocales } from 'utils';
import intl from 'react-intl-universal';

import styles from './styles';

// Note: if this uses PureComponent, the active links in the header stop working
class HeaderNavigation extends Component {

  constructor(props) {
    super(props);

    this.state = {
      menuActive: false
    };
  }

  handleNavItemClick = ({ target: { href } }) => {

    // Reload the page if the user clicked on the link for the page they're on
    if (href.endsWith(this.props.location.pathname)) {
      window.location.reload();
    }
  };
  handleLocaleNavItemClick = () => {
    window.location.reload();
  };

  toggleMenu = (menuActive) => this.setState({
    menuActive
  });

  renderBodyElement() {

    // If the mobile menu is active, prevent the document from moving
    if (this.state.menuActive) {
      return <body style={{ overflow: 'hidden' }} />;
    }

    return <body />
  }
  // getUrl(props, v, loc) {
  //   let pn = props.location.pathname;
  //   if(pn.indexOf(loc) !== -1) {
  //     return pn.replace(loc + '/', '/' + v + '/');
  //   } else {
  //     return '/' + v;
  //   }
  // }

  render() {
    const navClasses = [styles.navigation];
    const navLinkProps = {
      className: styles.navItem,
      activeClassName: styles.activeNavItem,
      onClick: this.handleNavItemClick
    };
    // const navLocaleLinkProps = {
    //   className: styles.navItem,
    //   activeClassName: styles.activeNavItem,
    //   onClick: this.handleLocaleNavItemClick
    // };
    

    if (this.state.menuActive) {
      navClasses.push(styles.navigationActive);
    }
    const loc = '';
    // const loc = '/' + intl.getInitOptions().currentLocale;
    
    // const locales = getLocales();
    
    return (
      <div>
        <Helmet>
          {this.renderBodyElement()}
        </Helmet>
        <NavToggle onClick={this.toggleMenu} />
        <nav className={navClasses.join(' ')}>
          <NavLink exact {...navLinkProps} to={ loc }>{intl.get('Image Resizer')}</NavLink>
          <NavLink {...navLinkProps} to={ loc + "/bulk-resize"}>{intl.get('Bulk Resize')}</NavLink>
          <NavLink {...navLinkProps} to={ loc + "/compress-images"}>{intl.get('Image Compressor')}</NavLink>
          <div className={styles.parentNavItem}>
            <NavLink {...navLinkProps} to="#">{intl.get('PDF Tools')}</NavLink>
            <nav className={styles.subNavigation}>
              <NavLink {...navLinkProps} to={ loc + "/pdf-compressor"}>{intl.get('PDF Compressor')}</NavLink>
              <NavLink {...navLinkProps} to={ loc + "/pdf-resize"}>{intl.get('PDF Resizer')}</NavLink>
            </nav>
          </div>
          <div className={styles.parentNavItem}>
            <NavLink {...navLinkProps} to="#">{intl.get('Convert Tools')}</NavLink>
            <nav className={styles.subNavigation}>
              <a className={styles.navItem} href="https://www.freeconvert.com/jpg-to-pdf" target="_blank">{intl.get('JPG TO PDF')}</a>
              <a className={styles.navItem} href="https://www.freeconvert.com/jpg-to-png" target="_blank">{intl.get('JPG TO PNG')}</a>
              <a className={styles.navItem} href="https://www.freeconvert.com/pdf-to-jpg" target="_blank">{intl.get('PDF TO JPG')}</a>
              <a className={styles.navItem} href="https://www.freeconvert.com/pdf-to-png" target="_blank">{intl.get('PDF TO PNG')}</a>
              <a className={styles.navItem} href="https://www.freeconvert.com/png-to-jpg" target="_blank">{intl.get('PNG TO JPG')}</a>
              <a className={styles.navItem} href="https://www.freeconvert.com/png-to-pdf" target="_blank">{intl.get('PNG TO PDF')}</a>
              <a className={styles.navItem} href="https://www.mp3cutter.com" target="_blank">{intl.get('MP3 Cutter')}</a>
            </nav>
          </div>
          <div className={styles.parentNavItem}>
            <NavLink {...navLinkProps} to="#">{intl.get('Features')}</NavLink>
            <nav className={styles.subNavigation}>
              <NavLink {...navLinkProps} to={ loc + "/features/crop-photo"}>{intl.get('Photo Cropping')}</NavLink>
              <NavLink {...navLinkProps} to={ loc + "/features/photo-editor"}>{intl.get('Photo Editing')}</NavLink>
              <NavLink {...navLinkProps} to={ loc + "/features/compress-images"}>{intl.get('Photo Compressing')}</NavLink>
            </nav>
          </div>
          {/* <div className={styles.parentNavItem}>
            <NavLink {...navLinkProps} to={loc}>{ locales[loc] }</NavLink>
            <nav className={styles.subNavigation}>
              {Object.keys(locales).map(v => (
                <NavLink {...navLocaleLinkProps} to={this.getUrl(this.props, v, loc)} key={v}>{locales[v]}</NavLink>
              ))}
            </nav>
          </div> */}
        </nav>
      </div>
    );
  }
}

export default withRouter(HeaderNavigation);



// WEBPACK FOOTER //
// ./src/components/HeaderNavigation/index.jsx